import { render, staticRenderFns } from "./DeSelect.vue?vue&type=template&id=5f8c460c&scoped=true"
import script from "./DeSelect.vue?vue&type=script&lang=js"
export * from "./DeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8c460c",
  null
  
)

export default component.exports